import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Download, Wallet } from 'lucide-react';

export default function PocketReconciliationCard({
  pocketDateFrom, setPocketDateFrom, pocketDateTo, setPocketDateTo,
  exportingPocket, onExport,
}) {
  return (
    <Card className="p-4 mb-8 bg-emerald-50 border-emerald-200">
      <div className="flex items-center gap-2 mb-3">
        <Wallet className="w-5 h-5 text-emerald-700" />
        <h3 className="font-bold text-lg">Pocket Pay Reconciliation</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Only includes CONFIRMED bookings paid via Pocket Card, Pocket QR, or Pocket Bill
        Payment — filtered by when the payment was <strong>processed</strong> (Brunei time),
        not the booking date, so it lines up with Pocket's daily settlement reports.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Payment Date From (Brunei)
          </Label>
          <Input
            type="date"
            value={pocketDateFrom}
            onChange={(e) => setPocketDateFrom(e.target.value)}
            className="h-10"
            data-testid="pocket-recon-date-from"
          />
        </div>
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Payment Date To (Brunei)
          </Label>
          <Input
            type="date"
            value={pocketDateTo}
            onChange={(e) => setPocketDateTo(e.target.value)}
            className="h-10"
            data-testid="pocket-recon-date-to"
          />
        </div>
        <Button
          onClick={onExport}
          disabled={exportingPocket}
          className="btn-volt gap-2 h-10"
          data-testid="export-pocket-reconciliation-button"
        >
          <Download className="w-4 h-4" />
          {exportingPocket ? 'Exporting...' : 'Export Pocket Reconciliation Excel'}
        </Button>
      </div>
    </Card>
  );
}
